/*
* iban.js
*
* IBAN/BIC helpers for DD payment validation (German IBAN, Mod-97, BIC format).
*
*/

/*******************************************************************************
* normalizeIban()
*
* Desc: Strip spaces and uppercase.
*
*/
export function normalizeIban(iban) {
    return (iban || '').replace(/\s/g, '').toUpperCase();
}


/*******************************************************************************
* isValidGermanIban()
*
* Desc: Validate DE IBAN format (22 chars) and Mod-97 checksum.
*
*/
export function isValidGermanIban(iban) {
    const normalized = normalizeIban(iban);

    if (!/^DE[0-9]{20}$/.test(normalized)) {
        return false;
    }

    const rearranged = normalized.slice(4) + normalized.slice(0, 4);
    const numeric = rearranged.replace(/[A-Z]/g, function (ch) {
        return (ch.charCodeAt(0) - 55).toString();
    });

    let remainder = 0;
    for (let i = 0; i < numeric.length; i += 7) {
        remainder = parseInt(String(remainder) + numeric.slice(i, i + 7), 10) % 97;
    }

    return remainder === 1;
}


/*******************************************************************************
* normalizeBic()
*
* Desc: Strip spaces and uppercase.
*
*/
export function normalizeBic(bic) {
    return (bic || '').replace(/\s/g, '').toUpperCase();
}


/*******************************************************************************
* isValidGermanBic()
*
* Desc: Validate German BIC format (8 or 11 chars, country code DE).
*
*/
export function isValidGermanBic(bic) {
    const normalized = normalizeBic(bic);

    return /^[A-Z]{4}DE[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(normalized);
}
